import { atom } from 'recoil'
import { useRecoilValue } from 'recoil'

export const playgroundAtom = atom({
    key: 'playgroundAtom',
    default: {
        profile: {
            firstName: 'Siriwat',
            lastName: 'Saengbanlang',
        },
        role: '',
    },
})

const usePlaygroundAtom = () => {
    const playground = useRecoilValue(playgroundAtom)
    return {
        ...playground,
    }
}

export default usePlaygroundAtom
